module.exports = __webpack_public_path__ + "img/P65-zh.1f810ee1.png";